import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'dynamicRangeType';

export class DynamicRangeType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
